import {apiActionsCountries} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import authService from "../../../auth/AuthService";
import {Types, Detail} from "../constants/CountriesActionConstants"

const loadAllCountries = (countries) => ({
    type: Types.LOAD_ALL_COUNTRIES,
    payload: countries
})

const toggleSortCountries = (sortKey) => ({
    type: Types.TOGGLE_COUNTRY_SORT,
    payload: sortKey
});

const fetchCountries = ({authToken}) => ({
    type: apiActionsCountries.GET_ALL_COUNTRIES,
    payload: {authToken}
});
const fetchOneCountry = (countryID, authToken) => ({
    type: apiActionsCountries.GET,
    payload: { countryID, authToken }
});
const fetchOneCountrySuccess = (countryDetail) => ({
    type: Detail.LOAD_COUNTRY_DETAIL,
    payload: {countryDetail}
});
const deleteOneCountry = (countryID, authToken) => ({
   type:apiActionsCountries.DELETE,
   payload: {countryID, authToken}
});
const unmountCountryDetail = () => ({
    type: Detail.CLEAR_COUNTRY_DETAIL_PAGE
});

const countryGlobalSearch = (value) => ({
    type: Types.COUNTRY_GLOBAL_SEARCH,
    payload: value
});

export function countryTableSearch(value) {
    return (dispatch) => {
        dispatch(countryGlobalSearch(value))
    }
}

export function fetchAllCountries() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchCountries({authToken}))
    }
}

export function fetchAllCountriesSuccess(countries) {
    return (dispatch) => {
        dispatch(loadAllCountries(countries))
    }
}

export function fetchCountryDetail(countryID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchOneCountry(countryID, authToken))
    }
}

export function fetchCountryDetailSuccess(countryDetail) {
    return (dispatch) => {
        dispatch(fetchOneCountrySuccess(countryDetail))
    }
}

export function deleteCountry(countryID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteOneCountry(countryID, authToken))
    }
}

export function unmountCountryDetailPage() {
    return (dispatch) => {
        dispatch(unmountCountryDetail())
    }
}

export function toggleCountrySort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortCountries(sortKey))
    }
}

const exports = {
    Types, 
    Detail,
}

export default exports;